import { useState, useEffect, useCallback } from 'react';
import { handleResponse } from '../services/apiService';
import { getChampionToken } from '../services/championService';
import configJson from '../config/config.json';
import store from '../redux/store';
import { createNotification } from '../redux/actions/uiActions';

const generalConfig = {
  method: 'GET',
  headers: { Authorization: `Bearer ${getChampionToken()}` },
};

const baseUrlTemplate = (url) => `${configJson.apiPath}${url}`;

export const useFetch = (url, passedConfig = {}, errorMessage = false) => {
  const [response, setResponse] = useState(passedConfig?.defaultRes);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [initRender, setInitRender] = useState(false);

  const fetchReq = useCallback(
    (extraConfig = {}) => {
      const config = { ...generalConfig, ...passedConfig, ...extraConfig };
      const _url = passedConfig?.rawUrl ? url : baseUrlTemplate(url);
      setLoading(true);
      fetch(_url, { ...config })
        .then(handleResponse)
        .then((_response) => {
          setResponse(_response);
          config.onSuccess?.(_response);
        })
        .catch((err) => {
          console.log({ err });
          setError(err.message);
          setResponse({});
          config.onError?.(err);
          if (errorMessage) store.dispatch(createNotification(errorMessage), 4000);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [url, passedConfig],
  );

  useEffect(() => {
    setInitRender(true);
    if (passedConfig.initReq) fetchReq();
  }, []);
  return [fetchReq, response, loading, error, initRender];
};
